import { render, staticRenderFns } from "./mamMasterCopySettingForm.vue?vue&type=template&id=6b47955d&scoped=true"
import script from "./mamMasterCopySettingForm.vue?vue&type=script&lang=js"
export * from "./mamMasterCopySettingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47955d",
  null
  
)

export default component.exports